import {
  PROJECT_METRICS_TAB_CONFIG,
  STUDIO_FINANCIAL_METRICS_TAB_CONFIG,
  COMMON_SYSTEM_TERMINOLOGY_TAB_CONFIG,
} from './config';

import type { IMetricsCategory } from '@gp/types/metrics';

export const METRICS_DEFAULT_ACTIVE_ID: IMetricsCategory = PROJECT_METRICS_TAB_CONFIG.key;

export const METRICS_DEFAULT_ACTIVE_IDS: IMetricsCategory[] = [
  PROJECT_METRICS_TAB_CONFIG.key,
  STUDIO_FINANCIAL_METRICS_TAB_CONFIG.key,
  COMMON_SYSTEM_TERMINOLOGY_TAB_CONFIG.key,
];

export const DISABLED_TAB_TIPS_WHEN_NO_SEARCH_RESULT = 'Sorry, no results. Please try other keywords.';
